// ======================================================================
// File Name       : ContentDistributionRegisterEditContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Col, Button, Modal } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';
import * as DistributionAction from '../../actions/ContentDistributionAction';
import DistributionOfferServiceSearch from '../../components/contentDistribution/DistributionOfferServiceSearch';
import DistributionContentList from '../../components/contentDistribution/DistributionContentList';
import DistributionCourseList from '../../components/contentDistribution/DistributionCourseList';

import DistributionOfferInfo from '../../components/contentDistribution/DistributionOfferInfo';
import ContentListDialog from '../../components/contentDistribution/RegistrationContentListSelection';
import CourseListDialog from '../../components/contentDistribution/RegistrationCourseListSelection';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM, DEFAULT_DATE_SHORT_FORMAT_SERVER, MODE, IS_SHOW_MENU_DEVELOP_FEATURE_51 } from '../../constants/index';
import { DISTRIBUTION_OFFER_TYPE } from '../../constants/ContentConstant';
import Header from '../../components/Header';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import {
  CONTENT_DISTRIBUTION,
  CONTENT_DISTRIBUTION_OFFER_LIST_DETAIL,
  CONTENT_DISTRIBUTION_LIST } from '../../constants/PathConstants';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import CustomLink from '../../components/button/CustomLink';
import * as Path from '../../constants/PathConstants';

class ContentDistributionRegisterEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      distributionServiceInfo: {
        institutionId: '',
        serviceCd: '',
        serviceName: '',
        distributionStatus: 1,
        offerType: IS_SHOW_MENU_DEVELOP_FEATURE_51 ?
        DISTRIBUTION_OFFER_TYPE.COURSE : DISTRIBUTION_OFFER_TYPE.CONTENT,
      },
      existedContentListInfo: {},
      distributionContentList: [],

      existedCourseListInfo: {},
      distributionCourseList: [],

      showContentListModal: false,
      showCourseListModal: false,

      startPosition: 0,
      ascendingDescendingSort: 0,
      sortType: '',
      returnMaxNum: RETURN_MAX_NUM,

      resultOK: false,
      showConfirmDialog: false,
      mode: MODE.NEW_MODE,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);

    this.onRegisterBtnClick = this.onRegisterBtnClick.bind(this);
    this.handleDeleteDistribution = this.handleDeleteDistribution.bind(this);
    this.handleTableDateTimeChange = this.handleTableDateTimeChange.bind(this);

    this.dialogCancel = this.dialogCancel.bind(this);
    this.dialogOk = this.dialogOk.bind(this);
    this.showSelectionListDialog = this.showSelectionListDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

    this.showConfirmDialog = this.showConfirmDialog.bind(this);
    this.hideConfirmDialog = this.hideConfirmDialog.bind(this);
    this.validation = this.validation.bind(this);

    this.goBack = this.goBack.bind(this);
    this.removeAllDistributionCourseOrContentFromList = this.removeAllDistributionCourseOrContentFromList.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    if (match.params.id) {
      const distributionServiceInfo = {
        ...this.state.distributionServiceInfo,
        ...{ serviceCd: match.params.id },
      };
      this.setState({ distributionServiceInfo, mode: MODE.EDIT_MODE, serviceCd: match.params.id },
      () => {
        this.getDistributionList();
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch(DistributionAction.resetData());
  }

  getDistributionList() {
    const { auth, dispatch } = this.props;
    const { searchInfo, serviceCd } = this.state;
    if (serviceCd) {
      this.props.dispatch(DistributionAction.getContentListToEdit(
      serviceCd, SELECT_TARGET_DATA.DATA)).then(() => {
        if (IS_SHOW_MENU_DEVELOP_FEATURE_51) {
          this.props.dispatch(DistributionAction.getCourseDistributionList(
            serviceCd, SELECT_TARGET_DATA.DATA));
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { contentDistribution } = nextProps;
    const { distributionOfferList } = contentDistribution;
    const {
      distributionServiceInfo,
      existedContentListInfo,
      distributionContentList,
      existedCourseListInfo,
      distributionCourseList,
      isSaveDistributionSuccess,
     } = distributionOfferList;
    const distributionServiceInfoFromState = this.state.distributionServiceInfo;
    distributionServiceInfoFromState.serviceCd = distributionServiceInfo.serviceCd;
    distributionServiceInfoFromState.serviceName = distributionServiceInfo.serviceName;
    this.setState({
      distributionServiceInfo: distributionServiceInfoFromState,
      existedContentListInfo,
      distributionContentList: distributionContentList || [],
      existedCourseListInfo,
      distributionCourseList: distributionCourseList || [],
      isSaveDistributionSuccess: isSaveDistributionSuccess || false,
    });
  }

  handleChange(event) {
    const { name } = event.target;
    let { value } = event.target;
    if (name === 'offerType') {
      value = parseInt(value, 10);
    }
    const distributionServiceInfo = {
      ...this.state.distributionServiceInfo,
      ...{ [name]: value },
    };
    this.setState({ distributionServiceInfo });
  }

  /**
 * Handle search when click on search button
 *
 */
  handleSearchBtn() {
    const { dispatch } = this.props;
    const { distributionServiceInfo } = this.state;
    if (distributionServiceInfo && distributionServiceInfo.institutionId) {
      const { institutionId } = distributionServiceInfo;
      const params = {
        targetInstitutionId: institutionId,
      };
      dispatch(DistributionAction.getContentDistributionServiceName(params));
    }
  }

  /**
 * Handle event when user register
 * @param page
 */
  onRegisterBtnClick() {
    this.setState({ showConfirmDialog: false });
    this.props.dispatch(showLoading());
    const { distributionServiceInfo, mode } = this.state;
    const { serviceCd } = distributionServiceInfo;
    if (mode === MODE.NEW_MODE) {
      const paramsRegisService = {
        editType: 0,
        distributionServiceInfo: {
          serviceCd,
          distributionStatus: null,
        },
      };
      this.props.dispatch(
        DistributionAction.registerContentDistribution(paramsRegisService),
      ).then(() => {
        this.saveDistributionList(serviceCd);
      });
    } else {
      this.saveDistributionList(serviceCd);
    }
  }

  saveDistributionList(serviceCd) {
    const { mode } = this.state;
    const isEdit = mode === MODE.EDIT_MODE;
    const contentData = this.saveContentDistributionList();
    let courseData = {
      addedContentList: [],
      updatedContentList: [],
      deletedContentList: [],
    };
    if (IS_SHOW_MENU_DEVELOP_FEATURE_51) {
      courseData = this.saveCourseDistributionList();
    }

    this.props.dispatch(
      DistributionAction.editDistributionList(
        serviceCd,
        contentData.addedContentList,
        contentData.updatedContentList,
        contentData.deletedContentList,
        courseData.addedCourseList,
        courseData.updatedCourseList,
        courseData.deletedCourseList),
    ).then(() => {
      this.props.dispatch(hideLoading());
      if (isEdit) {
        this.goBack();
      } else {
        this.props.history.push(CONTENT_DISTRIBUTION_LIST);
      }
    });
  }

  saveContentDistributionList() {
    const { distributionServiceInfo,
      distributionContentList,
      existedContentListInfo,
      mode } = this.state;
    const { serviceCd } = distributionServiceInfo;
    // get 3 content list add, update, delete
    const addedContentList = [];
    const updatedContentList = [];
    const deletedContentList = [];
    distributionContentList && distributionContentList.length &&
    distributionContentList.forEach((content) => {
      const startDate = moment(content.distributionStartDate)
        .format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
      const endDate = moment(content.distributionEndDate)
        .format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
      const item = {
        contentSecernId: content.contentSecernId,
        contentType: content.contentType,
        distributionStartDate: startDate,
        distributionEndDate: endDate,
      };
      const contentSecernIdMix = `${content.contentSecernId}_${content.contentType}`;
      if (!existedContentListInfo ||
          !existedContentListInfo.byCd ||
          !existedContentListInfo.byCd[contentSecernIdMix]) {
        // add to added content list
        addedContentList.push(item);
      } else if (existedContentListInfo.byCd[contentSecernIdMix]) {
        const existedContent = existedContentListInfo.byCd[contentSecernIdMix];
        if (existedContent.distributionStartDate !== startDate ||
            existedContent.distributionEndDate !== endDate) {
          // add to updated content list
          updatedContentList.push(item);
        }
      }
    }, this);

    const existedContentList = existedContentListInfo && existedContentListInfo.byCd ?
    Object.keys(existedContentListInfo.byCd).map(key => existedContentListInfo.byCd[key]) : [];
    // handle to get deleted Content List
    existedContentList && existedContentList.length &&
    existedContentList.forEach((content) => {
      let isDeleted = true;
      distributionContentList && distributionContentList.length &&
      distributionContentList.forEach((selectedContent) => {
        if (content.contentSecernId === selectedContent.contentSecernId && content.contentType === selectedContent.contentType) {
          isDeleted = false;
        }
      }, this);
      if (isDeleted) {
        const item = {
          contentSecernId: content.contentSecernId,
          contentType: content.contentType,
        };
        deletedContentList.push(item);
      }
    }, this);
    return {
      addedContentList,
      updatedContentList,
      deletedContentList,
    };
  }

  saveCourseDistributionList() {
    const { distributionServiceInfo,
      distributionCourseList,
      existedCourseListInfo,
      mode } = this.state;
    const { serviceCd } = distributionServiceInfo;
    // get 3 Course list add, update, delete
    const addedCourseList = [];
    const updatedCourseList = [];
    const deletedCourseList = [];
    distributionCourseList && distributionCourseList.length &&
    distributionCourseList.forEach((course) => {
      const startDate = moment(course.distributionStartDate)
        .format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
      const endDate = moment(course.distributionEndDate)
        .format(DEFAULT_DATE_SHORT_FORMAT_SERVER);
      const item = {
        courseSecernId: course.courseSecernId,
        distributionStartDate: startDate,
        distributionEndDate: endDate,
      };
      if (!existedCourseListInfo ||
          !existedCourseListInfo.byCd ||
          !existedCourseListInfo.byCd[course.courseSecernId]) {
        // add to added Course list
        addedCourseList.push(item);
      } else if (existedCourseListInfo.byCd[course.courseSecernId]) {
        const existedCourse = existedCourseListInfo.byCd[course.courseSecernId];
        if (existedCourse.distributionStartDate !== startDate ||
            existedCourse.distributionEndDate !== endDate) {
          // add to updated Course list
          updatedCourseList.push(item);
        }
      }
    }, this);

    const existedCourseList = existedCourseListInfo && existedCourseListInfo.byCd ?
    Object.keys(existedCourseListInfo.byCd).map(key => existedCourseListInfo.byCd[key]) : [];

    // handle to get deleted Course List
    existedCourseList && existedCourseList.length &&
    existedCourseList.forEach((course) => {
      let isDeleted = true;
      distributionCourseList && distributionCourseList.length &&
      distributionCourseList.forEach((selectedCourse) => {
        if (course.courseSecernId === selectedCourse.courseSecernId) {
          isDeleted = false;
        }
      }, this);
      if (isDeleted) {
        const item = {
          courseSecernId: course.courseSecernId,
        };
        deletedCourseList.push(item);
      }
    }, this);
    return {
      addedCourseList,
      updatedCourseList,
      deletedCourseList,
    };
  }

  handleTableDateTimeChange(value, id, name, contentType) {
    const { distributionContentList, distributionCourseList, distributionServiceInfo } = this.state;
    const { offerType } = distributionServiceInfo;
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      this.props.dispatch(
        DistributionAction.changeDateTimeOfContent(value, id, name, distributionContentList, contentType),
      );
    } else if (offerType === DISTRIBUTION_OFFER_TYPE.COURSE) {
      this.props.dispatch(
        DistributionAction.changeDateTimeOfCourse(value, id, name, distributionCourseList),
      );
    }
  }

  handleDeleteDistribution(id, contentType) {
    const { distributionContentList, distributionCourseList, distributionServiceInfo } = this.state;
    const { offerType } = distributionServiceInfo;
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      this.props.dispatch(
        DistributionAction.deleteContentFromDistributionList(distributionContentList, id, contentType));
    } else if (offerType === DISTRIBUTION_OFFER_TYPE.COURSE) {
      this.props.dispatch(
        DistributionAction.deleteCourseFromDistributionList(distributionCourseList, id));
    }
  }

  showSelectionListDialog() {
    const { distributionServiceInfo } = this.state;
    const { offerType } = distributionServiceInfo;
    if (offerType) {
      this.setState({ showContentListModal: true });
    } else {
      this.setState({ showCourseListModal: true });
    }
  }

  dialogCancel() {
    this.closeDialog();
  }

  closeDialog() {
    const { distributionServiceInfo } = this.state;
    const { offerType } = distributionServiceInfo;
    if (offerType === DISTRIBUTION_OFFER_TYPE.CONTENT) {
      this.setState({ showContentListModal: false });
    } else if (offerType === DISTRIBUTION_OFFER_TYPE.COURSE) {
      this.setState({ showCourseListModal: false });
    }
  }

  dialogOk(selectedList) {
    if (selectedList && selectedList.length) {
      const { distributionServiceInfo } = this.state;
      const { offerType } = distributionServiceInfo;
      this.props.dispatch(
          DistributionAction.addItemToDistributionList(selectedList, offerType),
        );
    }
    this.closeDialog();
  }

  showConfirmDialog() {
    if (!this.validation()) {
      return;
    }
    const distributionContentList = [...this.state.distributionContentList];
    const listLength = distributionContentList.length;
    for (let i = 0; i < listLength; i++) {
      if (
        distributionContentList[i].distributionEndDate === null ||
        distributionContentList[i].distributionEndDate === '' ||
        distributionContentList[i].distributionStartDate === null ||
        distributionContentList[i].distributionStartDate === ''
      ) {
        return;
      }
    }
    this.setState({ showConfirmDialog: true });
  }

  hideConfirmDialog() {
    this.setState({ showConfirmDialog: false });
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  goBack() {
    this.props.history.goBack();
  }

  removeAllDistributionCourseOrContentFromList(isContent) {
    const { dispatch } = this.props;
    dispatch(DistributionAction.removeAllDistributionCourseOrContentFromList(isContent));
  }

  render() {
    this.refsToValidate = [];
    const {
      startPosition,
      distributionContentList,
      returnMaxNum,
      isSaveDistributionSuccess,
      distributionServiceInfo,
      existedContentListInfo,
      dialogContentList,
      existedCourseListInfo,
      dialogCourseList,
      showContentListModal,
      searchResult,
      showCourseListModal,
      distributionCourseList,
      showConfirmDialog,
      mode,
    } = this.state;
    const { institutionId, serviceCd, serviceName, offerType } = distributionServiceInfo;
    const isEdit = mode === MODE.EDIT_MODE;
    const isDistributionContent = offerType === DISTRIBUTION_OFFER_TYPE.CONTENT;
    return (
      <Col sm={12} className="margin-bottom-10">
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DISTRIBUTION_LIST}
          text="コンテンツ配布管理に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name={isEdit ? 'コンテンツ配布先情報の編集' : 'コンテンツ配布先情報の新規登録'} />
        <Col>
          <DistributionOfferServiceSearch
            serviceName={serviceName}
            institutionId={institutionId}
            offerType={offerType}
            onSearchBtnClick={this.handleSearchBtn}
            handleChange={this.handleChange}
            isEdit={isEdit}
          />
          <DistributionOfferInfo
            offerType={offerType}
            handleChange={this.handleChange}
            onShowSelectionListBtnClick={this.showSelectionListDialog}
            disabledButton={!serviceName}
            isEdit={isEdit}
            isDistributionContent={isDistributionContent}
            removeAllDistributionCourseOrContentFromList={this.removeAllDistributionCourseOrContentFromList}
          />
          {isDistributionContent ?
            <DistributionContentList
              existedContentListInfo={existedContentListInfo}
              distributionContentList={distributionContentList}
              handleDateTimeChange={this.handleTableDateTimeChange}
              handleDeleteDistribution={this.handleDeleteDistribution}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
            /> :
            <DistributionCourseList
              existedCourseListInfo={existedCourseListInfo}
              distributionCourseList={distributionCourseList}
              handleDateTimeChange={this.handleTableDateTimeChange}
              handleDeleteDistribution={this.handleDeleteDistribution}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
            />
          }
        </Col>
        {!isEdit ?
          <Col className="text-center">
            <Button
              variant="primary"
              className="btn-96 text-center"
              onClick={this.showConfirmDialog}
              disabled={
                !serviceName ||
                !((distributionContentList &&
                distributionContentList.length) ||
                (distributionCourseList &&
                distributionCourseList.length))
              }
            >
              OK
            </Button>
          </Col> :
          <Col sm={12} className="text-center margin-top-20">
            <Button variant="default" className="btn-96" onClick={this.goBack}>
              キャンセル
            </Button>
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.showConfirmDialog}
              disabled={
                !serviceName
              }
            >
              登録
            </Button>
          </Col>}
        {showContentListModal && <ContentListDialog
          showModal={showContentListModal}
          onDialogCancel={this.dialogCancel}
          onDialogOK={this.dialogOk}
          isEditMode={isEdit}
        />}
        {showCourseListModal && <CourseListDialog
          showModal={showCourseListModal}
          onDialogCancel={this.dialogCancel}
          onDialogOK={this.dialogOk}
          isEditMode={isEdit}
        />}
        <DialogConfirm
          showModal={showConfirmDialog}
          onCancel={this.hideConfirmDialog}
          content={MessageTemplate.MSG_CONFIRM_UPDATE}
          onOK={this.onRegisterBtnClick}
        />
      </Col>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  ...{ contentDistribution: state.contentDistribution, auth: state.authed.authedUser },
});

export default connect(mapStateToProps)(ContentDistributionRegisterEditContainer);
